import { createMapAction } from "chalet-shared";

export const actionCreators = {
    setElectronVersion: createMapAction("SET_ELECTRON_VERSION", (x: { version: string }) => x),
};
